import styled from 'styled-components'

export const TitleRoxo = styled.div`
  font-size: 3.25rem;
  font-weight: 900;
  color: var(--purple);

  @media (max-width: 447px) {
    font-size: 2.5rem;
  }
`
